<template>
    <ValidationObserver ref="observer">
        <b-row>
            <b-col>
                <component-header
                    title="Create Privacy Setting"
                    :isLoading="loading"
                    :hasback="true"
                    :hasSearch="false"
                    :hasCreate="false"
                    :hasReload="false"
                    backButtonText="Back"
                    @back-press="backBtn"
                />
                <b-card>
                    <div class="selections mb-2">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="app"
                        >
                            <div
                                class="d-flex flex-column flex-md-row align-items-md-center mb-3 mr-2"
                            >
                                <label class="mr-2">Select App:</label>
                                <b-form-select
                                    v-model="selectedScope"
                                    placeholder="Select App"
                                    :options="scopeOptions"
                                    class="w-auto"
                                ></b-form-select>
                            </div>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="page"
                        >
                            <div
                                class="d-flex flex-column flex-md-row align-items-md-center mb-3"
                            >
                                <label class="mr-2">Select Type:</label>
                                <b-form-select
                                    v-model="selectedType"
                                    :options="typeOptions"
                                    class="w-auto"
                                ></b-form-select>
                            </div>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </div>
                    <b-form-group>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="title"
                        >
                            <b-form-input
                                v-model="title"
                                placeholder="Enter Title"
                            ></b-form-input>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-form-group>
                </b-card>

                <b-card
                    v-for="(section, index) in subSections"
                    :key="section.id"
                    class="sub-section-card"
                >
                    <div>
                        <div
                            class="d-flex justify-content-between align-items-center mb-2"
                        >
                            <label>
                                Sub Section {{ index + 1 }}
                                <span v-if="index === 0" class="text-muted">
                                    (By Default)
                                </span>
                            </label>
                            <div class="button-group">
                                <b-button
                                    v-if="index > 0"
                                    variant="link"
                                    class="p-0"
                                    @click="removeSubSection(index)"
                                >
                                    <span
                                        class="fa fa-minus-circle fa-2x text-danger"
                                    ></span>
                                </b-button>
                                <b-button
                                    variant="link"
                                    class="p-0"
                                    @click="addSubSection"
                                >
                                    <span
                                        class="fa fa-plus-circle fa-2x text-success"
                                    ></span>
                                </b-button>
                            </div>
                        </div>

                        <b-form-group>
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="sub title"
                            >
                                <b-form-input
                                    v-model="section.title"
                                    placeholder="Enter Title"
                                ></b-form-input>
                                <span class="validate-error" style="color: red">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="content"
                        >
                            <vue-editor
                                v-model="section.content"
                                class="mb-3"
                            ></vue-editor>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </div>
                </b-card>

                <div
                    class="buttons d-flex justify-content-center gap-2 mb-4 mt-4"
                >
                    <b-button
                        variant="danger"
                        class="save-btn mr-2"
                        @click="backBtn"
                    >
                        CANCEL
                    </b-button>
                    <b-button variant="primary" class="save-btn" @click="save">
                        SAVE
                    </b-button>
                </div>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";

export default {
    name: "CreatePrivacySetting",
    components: {
        VueEditor,
        ComponentHeader,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            loading: false,
            selectedType: null,
            selectedScope: null,
            title: "",
            subSections: [{ id: Date.now(), title: "", content: "" }],
            typeOptions: [
                { value: null, text: "Select Type" },
                { value: "termsCondition", text: "Terms & Conditions" },
                { value: "privacyPolicy", text: "Privacy Policy" },
                { value: "aboutUs", text: "About Us" },
            ],
            scopeOptions: [
                { value: null, text: "Select App" },
                { value: "customer", text: "Customer" },
                { value: "seller", text: "Seller" },
                { value: "agent", text: "Agent" },
            ],
        };
    },
    methods: {
        backBtn() {
            this.$router.push({ path: "/privacy-setting/" });
        },
        addSubSection() {
            this.subSections.push({
                id: Date.now() + Math.random(),
                title: "",
                content: "",
            });
        },
        removeSubSection(index) {
            if (this.subSections.length > 1) {
                this.subSections.splice(index, 1);
            }
        },
        async save() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            const sections = this.subSections.map((section) => ({
                subtitle: section.title,
                description: section.content,
            }));

            const data = {
                tenant: this.$currentUserData._id,
                sections: sections,
                title: this.title,
                slug: this.title
                    .toLowerCase()
                    .trim()
                    .replace(/\s+/g, "-")
                    .replace(/[^\w\-]+/g, "")
                    .replace(/\-\-+/g, "-"),
                content: this.selectedType,
                scope: this.selectedScope,
            };

            await this.$store
                .dispatch("privacySetting/createPrivacySettingAction", data)
                .then((result) => {
                    this.$swal({
                        title: "Success",
                        text: "Privacy setting added successfully!!",
                        type: "success",
                    });
                    this.$router.push({ path: "/privacy-setting/" });
                });
        },
    },
};
</script>

<style>
.selections {
    display: flex;
    flex-direction: column;
}

@media (min-width: 768px) {
    .selections {
        flex-direction: row;
        justify-content: flex-start;
    }
}

.type-selection,
.scope-selection {
    display: flex;
    align-items: center;
}

.button-group {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.buttons {
    width: 50%;
    padding-bottom: 30px;
    margin: 0 auto;
}

.sub-section-card {
    margin-top: 20px;
}
</style>
